import { Box } from '@mui/material'
import React from 'react'

const Header = () => {
    return (
        <Box sx={{ width: "100%", height: "20px", backgroundColor: theme => theme.palette.customColors.indigo700 }}>

        </Box>
    )
}

export default Header